import { useQuery } from '@tanstack/react-query';
import { getEmailConfigurationSettings } from './getEmailConfigurationSettings';
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { mockedEmailConfiguration } from './mock';
import { EmailConfigurationModel } from './types';
import { QUERY_KEY_SETTINGS_EMAIL, SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

type Props = {
  companyId: string
}

export function useQueryEmailConfigurationSettings(props: Props) {
  const { companyId } = props
  return useQuery<EmailConfigurationModel>({
    queryKey: [QUERY_KEY_SETTINGS_EMAIL, companyId],
    queryFn: async () => {
      if (COMPANY_API_SETTINGS_MOCKED) { // @TODO
        return mockedEmailConfiguration
      }
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await getEmailConfigurationSettings(props);
      return data;
    },
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
